import React from 'react';
import '../less';

import List from '../views/list.c';
import DetailedNews from '../views/detailedNews.c';

export default function template() {
    let Component = null;

    if (this.props.match.params && this.props.match.params.id) {
        Component = DetailedNews;
    } else {
        Component = List;
    }

    return (
        <div className="module-news">
            <Component {...this.props} />
        </div>
    );
}
